/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S2_P2Inputs */

const tr_mesafeli_s2_p2 = /** @type {(inputs: Mesafeli_S2_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sözleşme 6502 sayılı Tüketicinin Korunması Hakkında Kanun, Mesafeli Sözleşmeler Yönetmeliği (RG 27.11.2014, son değişiklik RG 24.05.2025 sayı 32909), 6098 sayılı Türk Borçlar Kanunu ve 6698 sayılı Kişisel Verilerin Korunması Kanunu çerçevesinde akdedilmiştir.`)
};

const en_mesafeli_s2_p2 = /** @type {(inputs: Mesafeli_S2_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Agreement has been concluded within the framework of Law No. 6502 on Consumer Protection, the Mesafeli Sözleşmeler Yönetmeliği (Distance Contracts Regulation, Official Gazette 27.11.2014, last amended Official Gazette 24.05.2025 No. 32909), the Turkish Code of Obligations No. 6098 and Law No. 6698 on the Protection of Personal Data.`)
};

const de_mesafeli_s2_p2 = /** @type {(inputs: Mesafeli_S2_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Vertrag wurde im Rahmen des Gesetzes Nr. 6502 über den Verbraucherschutz, der Mesafeli Sözleşmeler Yönetmeliği (Verordnung über Fernabsatzverträge, Amtsblatt 27.11.2014, letzte Änderung Amtsblatt 24.05.2025 Nr. 32909), des türkischen Obligationengesetzes Nr. 6098 und des Gesetzes Nr. 6698 zum Schutz personenbezogener Daten geschlossen.`)
};

const ru_mesafeli_s2_p2 = /** @type {(inputs: Mesafeli_S2_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Договор заключён в рамках Закона № 6502 о защите прав потребителей, Mesafeli Sözleşmeler Yönetmeliği (Положение о дистанционных договорах, Официальная газета от 27.11.2014, последнее изменение Официальная газета от 24.05.2025 № 32909), Турецкого обязательственного кодекса № 6098 и Закона № 6698 о защите персональных данных.`)
};

/**
* | output |
* | --- |
* | "The Agreement has been concluded within the framework of Law No. 6502 on Consumer Protection, the Mesafeli Sözleşmeler Yönetmeliği (Distance Contracts Regula..." |
*
* @param {Mesafeli_S2_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s2_p2 = /** @type {((inputs?: Mesafeli_S2_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S2_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s2_p2(inputs)
	if (locale === "de") return de_mesafeli_s2_p2(inputs)
	if (locale === "ru") return ru_mesafeli_s2_p2(inputs)
	return tr_mesafeli_s2_p2(inputs)
});